import { render, staticRenderFns } from "./MailTemplateTypeForm.vue?vue&type=template&id=610584f4&scoped=true"
import script from "./MailTemplateTypeForm.vue?vue&type=script&lang=js"
export * from "./MailTemplateTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610584f4",
  null
  
)

export default component.exports